import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class GrupoForm extends Component {
  state = {
    registro: {
      grp_codigo: '',
      grp_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        this.refs.grp_codigo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.grp_descricao) || (this.state.registro.grp_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }

    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { grp_idf, grp_codigo, grp_descricao } = this.state.registro;

    return (
      <Modal
        title={grp_idf ? "Edição de Grupo" : "Cadastro de Grupo"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Código</span>
              <InputForm
                id="grp_codigo"
                ref="grp_codigo"
                maxLength={30}
                onChange={this.onChange}
                value={grp_codigo}
                validator={value => Boolean(value)}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={20}>
              <span>Descrição</span>
              <InputForm
                id="grp_descricao"
                ref="grp_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={grp_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GrupoForm.js